import { Fence, LinkedDevices } from 'interfaces/fences';
import api from '../api';
import { FenceSupesp, FenceSupespUpload } from 'interfaces/statistics';

export const ServiceEstatisticas = {
  get: ({
    cidades,
    tipoArquivos,
  }: {
    cidades: string[];
    tipoArquivos: string[];
  }): Promise<FenceSupesp[]> =>
    api.post('/rotas/supesp/cerca/geometria/all', { cidades, tipoArquivos }),
  save: (body: FenceSupespUpload[]) => {
    return api.post('/rotas/supesp/cerca/geometria', body);
  },
};
